<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" v-if="(accType === 2  && isHavePermission('user:company:createCompanyInfo')) || (accType === 1 && isHavePermission('user:person:createCompanyInfo'))"
              @click="createCompanyInfo(0, {})">开通子账户
      </Button>
      <!--      <Button status="primary" icon="ios-add" @click="bindCompanyInfo()" style="margin-left: 10px" v-if="accType == 2"-->
      <!--      >关联子账户-->
      <!--      </Button>-->
      <Button icon="md-refresh" @click="refresh" style="margin-left: 10px">刷新</Button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          auto-resize
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="companyListData"
      >
        <vxe-table-column field="acthion" title="操作" width="240">
          <template slot-scope="{ row }">
            <div>
              <a @click.stop="createCompanyInfo(1, row)">修改子账户</a>
              <a style="margin-left: 10px;" @click.stop="getAccount(row)">查看结算账户</a>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="busiSubjectName" title="所属公司"></vxe-table-column>
        <vxe-table-column field="memName" title="企业名称" v-if="accType == 2"></vxe-table-column>
        <vxe-table-column field="identiNum" title="统一社会信用代码" v-if="accType == 2"></vxe-table-column>
        <vxe-table-column field="realname" title="法人姓名" v-if="accType == 2"></vxe-table-column>
        <vxe-table-column field="idno" title="法人身份证号码" v-if="accType == 2"></vxe-table-column>
        <vxe-table-column field="memName" title="姓名" v-if="accType == 1"></vxe-table-column>
        <vxe-table-column field="identiNum" title="身份证号码" v-if="accType == 1"></vxe-table-column>
        <vxe-table-column field="phoneNumber" title="手机号" v-if="accType == 1"></vxe-table-column>
        <vxe-table-column field="subAcc" title="子账户帐号" width="210"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal
        v-model="isShowAddModal"
        :title="modalTitle"
        width="600"
        height="550"
        transfer
        resize
    >
      <div>
        <vxe-form
            ref="xForm1"
            class="my-form2"
            title-align="right"
            title-width="150"
            :data="formData"
            :rules="formRules"
            @submit="submitEvent"
            @reset="cancelEvent"
        >
          <vxe-form-item title="所属公司" field="busiSubjectName" span="24">
            <template v-if="type == 0">
              <vxe-pulldown ref="companyDown" transfer>
                <template v-slot>
                  <div
                      class="sel-link-text"
                      @click="focusEvent('companyDown')"
                      target="_black"
                      style="
                      cursor: pointer;
                      display: inline-block;
                      width: 100%;
                      text-algin: center;
                    "
                  >
                    {{
                      formData.busiSubjectName
                          ? formData.busiSubjectName
                          : "请选择所属公司"
                    }}
                    <i
                        class="vxe-input--suffix-icon fa vxe-icon--arrow-bottom"
                    ></i>
                  </div>
                </template>
                <template v-slot:dropdown>
                  <div class="company-dropdown4">
                    <Input
                        search
                        suffix="ios-search"
                        v-model="searchName"
                        placeholder
                        @keyup.enter.native="search"
                        @on-search="search"
                        style="width: 200px"
                    />
                    <vxe-grid
                        highlight-hover-row
                        auto-resize
                        height="auto"
                        :loading="loading"
                        :pager-config="tablePage"
                        :data="tableData"
                        :columns="tableColumn"
                        @cell-click="cellClickEvent"
                        @page-change="pageChange"
                    >
                    </vxe-grid>
                  </div>
                </template>
              </vxe-pulldown>
            </template>
            <template v-if="type == 1">
              {{
                formData.busiSubjectName
                    ? formData.busiSubjectName
                    : "请选择所属公司"
              }}
            </template>
          </vxe-form-item>
          <vxe-form-item title="企业名称" field="compName" span="24" v-if="userType == 2">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.compName"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm1.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="统一社会信用代码" field="identiNum" span="24" v-if="userType == 2">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.identiNum"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm1.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>

          <vxe-form-item title="法人姓名" field="realname" span="24" v-if="userType == 2">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.realname"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm1.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="姓名" field="realname" span="24" v-if="userType == 1">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.realname"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm1.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="法人身份证号码" field="idno" span="24" v-if="userType == 2">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.idno"
                  placeholder=""
                  clearable
                  @input="$refs.xForm1.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="身份证号码" field="identiNum" span="24" v-if="userType == 1">
            <template v-slot="scope">
              <vxe-input
                  disabled
                  v-model="formData.identiNum"
                  placeholder=""
                  clearable
                  @input="$refs.xForm1.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item v-if="!isUpdate" title="结算银行卡号" field="bindAccNum" span="24">
            <template v-slot="scope">
              <vxe-pulldown ref="accDown" transfer>
                <template v-slot>
                  <vxe-input
                      v-model="formData.bindAccNum"
                      @change="editBankCount"
                      @blur="accBlur"
                      placeholder="请输入结算银行卡号"
                      @input="$refs.xForm1.updateStatus(scope)"
                  >
                    <template #suffix>
                      <Icon
                          style="color: #2d8cf0; font-size: 20px; cursor: pointer"
                          type="ios-list-box-outline"
                          @click="focusEvent('accDown')"
                      />
                    </template>
                  </vxe-input>
                </template>
                <template v-slot:dropdown>
                  <div class="company-dropdown4">
                    <vxe-grid
                        highlight-hover-row
                        auto-resize
                        height="auto"
                        :loading="loading"
                        :data="accTableData"
                        :columns="accTableColumn"
                        empty-text="没有更多数据了！"
                        @cell-click="accCellClickEvent"
                    >
                      <template v-slot:empty>
                        <span style="color: #2d8cf0;">
                          <p>暂无数据</p>
                        </span>
                      </template>
                    </vxe-grid>
                  </div>
                </template>
              </vxe-pulldown>
            </template>
          </vxe-form-item>
          <vxe-form-item title="结算开户银行" field="bindOpenBankName" span="24">
            <template v-slot="scope">
              <vxe-pulldown ref="bankDown" transfer style="width: 100%">
                <template v-slot>
                  <vxe-input
                      v-model="formData.bindOpenBankName"
                      :placeholder="placeholderTxt"
                      @focus="bankFocusEvent"
                      @keyup="bankKeyupEvent"
                      @blur="checkOrg(scope)"
                  >
                    <template #suffix v-if="isExist">
                      <div class="input-inner-switch">
                        <em>手动输入</em>
                        <vxe-switch @change="changeSwitch" v-model="isInputBank" open-label="是"
                                    close-label="否"></vxe-switch>
                      </div>
                    </template>
                  </vxe-input>
                </template>
                <template v-slot:dropdown>
                  <div class="my-dropdown1">
                    <div
                        class="list-item1"
                        v-for="item in bankList"
                        :key="item.id"
                        @click="bankSelectEvent(item, scope)"
                    >
                      <i class="fa fa-user-o"></i>
                      <span>{{ item.orgName }}</span>
                    </div>
                  </div>
                </template>
              </vxe-pulldown>
            </template>
          </vxe-form-item>
          <span class="bank-tip" v-if="isExist"><Icon type="ios-information-circle-outline"/>若未查询到开户行，请切换到手动输入</span>
          <vxe-form-item field="drawOpenOrgNum" v-if="isInputBank" title="开户行联行号" span="24">
            <!-- v-if="isShowDrawOpenOrgNum" -->
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.drawOpenOrgNum"
                  placeholder="请输入开户行联行号"
                  @change="editDrawOpenOrgNum()"
                  type="number"
                  @input="$refs.xForm1.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <!-- <vxe-form-item v-if="!isUpdate" title="是否跨行" field="isCrossLine" span="24">
            <template v-slot>
              <vxe-radio-group v-model="formData.isCrossLine">
                <vxe-radio label="02">是</vxe-radio>
                <vxe-radio label="01">否</vxe-radio>
              </vxe-radio-group>
            </template>
          </vxe-form-item> -->
          <vxe-form-item align="center" span="24">
            <template v-slot>
              <vxe-button type="submit" status="primary">确定</vxe-button>
              <!-- <vxe-button type="submit" status="primary" @click="editEvent(formData)" v-else>确定</vxe-button> -->
              <vxe-button type="reset">取消</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </div>
    </vxe-modal>
    <vxe-modal
        v-model="isShowAddTwoModal"
        title="关联子账户"
        width="600"
        height="550"
        transfer
        resize
    >
      <div>
        <vxe-form
            ref="xForm"
            class="my-form2"
            title-align="right"
            title-width="150"
            :data="formDataTwo"
            @submit="submitEventTwo"
            @reset="cancelEvent"
        >
          <vxe-form-item title="所属公司" field="busiSubjectName" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formDataTwo.busiSubjectName"
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="统一社会信用代码" field="identiNum" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formDataTwo.identiNum"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="法人姓名" field="realname" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formDataTwo.realname"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="法人身份证号码" field="idno" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formDataTwo.idno"
                  placeholder=""
                  clearable
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="结算账户" field="bindAccName" span="24">
            <template>
              <vxe-input
                  v-model="formDataTwo.bindAccName"
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="结算银行账号" field="bindAccNum" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formDataTwo.bindAccNum"
                  disabled
                  clearable
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
              title="结算开户银行"
              field="bindOpenBankName"
              span="24"
          >
            <template>
              <vxe-input
                  v-model="formDataTwo.bindOpenBankName"
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="是否跨行" field="isCrossLine" span="24">
            <template v-slot>
              <vxe-radio-group v-model="formDataTwo.isCrossLine" disabled>
                <vxe-radio label="02">是</vxe-radio>
                <vxe-radio label="01">否</vxe-radio>
              </vxe-radio-group>
            </template>
          </vxe-form-item>
          <vxe-form-item align="center" span="24">
            <template v-slot>
              <vxe-button type="submit" status="primary">确定</vxe-button>
              <!-- <vxe-button type="submit" status="primary" @click="editEvent(formData)" v-else>确定</vxe-button> -->
              <vxe-button type="reset">取消</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </div>
    </vxe-modal>
    <vxe-modal v-model="accountModal" width="1400" height="800" position="center" title="已关联结算账户" destroy-on-close>
      <link-account-list ref="linkAccountList"></link-account-list>
    </vxe-modal>
    <vxe-modal
        title="新增银行账户"
        v-model="createAccountModal"
        width="600"
        height="380"
        position="center"
        transfer
        destroy-on-close
        @close="closeAddAccount"
    >
      <add-bank-account ref="addBankAccount" :userId="userId" :userName="userName"
                        @close="closeAccount"></add-bank-account>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {hideLoading, isEmpty, showLoading} from "@/utils/util";
import LinkAccountList from "./LinkAccountList";
import addBankAccount from "./addBankAccount";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {LinkAccountList, addBankAccount},
  props: {
    userId: Number,
    accType: Number,
    idcardNum: String,
  },
  mixins: [getAuthOrization],
  data() {
    const regNumber = /^\d{12}$/;
    const openOrgNumValid = ({cellValue}) => {
      if (!regNumber.test(this.formData.drawOpenOrgNum)) {
        return Promise.reject(
            new Error("请输入正确的联行号")
        );
      }
    };
    const regNumber1 = /^\d{0,30}$/;
    const accountNumValid = ({cellValue}) => {
      if (!regNumber1.test(this.formData.bindAccNum)) {
        return Promise.reject(
            new Error("请输入正确的银行帐号")
        );
      }
    };
    return {
      createAccountModal: false,
      accountModal: false,
      userType: null,
      loading: false,
      companyListData: [],
      isShowAddTwoModal: false,
      userName: null,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      isShowAddModal: false,
      modalTitle: "开通子账户",
      formData: {
        realname: null, // 法人姓名
        idno: null, // 法人身份证号码
        identiNum: null, // 统一社会信用代码
        bindAccName: null, // 结算账户
        bindAccNum: null, // 结算银行账号
        busiSubjectName: null, // 公司名称
        subjectId: null, // 平台公司id
        bindOpenBankName: null, // 结算开户银行
        bindOpenOrgNum: null,
        isCrossLine: "02",
        phoneNumber: null
      },
      formDataTwo: {
        realname: null, // 法人姓名
        idno: null, // 法人身份证号码
        identiNum: null, // 统一社会信用代码
        bindAccName: null, // 结算账户
        bindAccNum: null, // 结算银行账号
        busiSubjectName: null, // 公司名称
        subjectId: null, // 平台公司id
        bindOpenBankName: null, // 结算开户银行
        bindOpenOrgNum: null,
        isCrossLine: "02",
        phoneNumber: null
      },
      formRules: {
        realname: [{required: true, message: "请输入姓名"}],
        // idno: [{required: true, message: "请输入身份证号码"}],
        identiNum: [{required: true, message: "请输入证件号"}],
        bindAccName: [{required: true, message: "请选择结算账户"}],
        bindAccNum: [{max: 30, required: true, message: "请输入银行账号"}, {validator: accountNumValid}],
        busiSubjectName: [{required: true, message: "请选择公司名称"}],
        bindOpenBankName: [{required: true, message: "请输入结算开户银行"}],
        drawOpenOrgNum: [{min: 12, max: 12, required: true, message: "请输入正确的联行号"}, {validator: openOrgNumValid}],
      },
      contractListType: [], // test
      filterChainId: "", // test
      chainIdPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      }, // test
      chainIdData: [], // test
      chainIdColumn: [{field: "chainNum", title: "主订单编号"}], // test
      type: 0, // 0新增， 1编辑
      subjectType: 0, // 0 平台方
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      },
      tableData: [],
      tableColumn: [{field: "name", title: "公司名称"}],
      searchName: "",
      accTablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      },
      accTableData: [],
      accTableColumn: [
        {field: "accountNum", title: "账户号"},
        {field: "openBankName", title: "开户行"},
      ],
      bankList: [],
      isUpdate: false,
      isInputBank: false,
      isExist: false,
      idRead: false,
      idNoRead: false
    };
  },
  computed: {
    placeholderTxt() {
      return this.isInputBank ? "请输入结算开户行" : "请选择结算开户行";
    },
  },
  mounted() {
    this.getAccList();
    console.log(this.accType + "xxxx");
  },
  methods: {
    clearV() {
      this.$refs.xForm1.clearValidate();
    },
    accBlur(val) {
      this.isExist = true;
      this.formData.bindOpenBankName = '';
      this.accTableData.map(i => {
        if (val.value === i.accountNum) {
          this.formData.bindOpenBankName = i.openBankName;
          this.isExist = false;
        }
      })
    },
    changeSwitch(val) {
      this.$set(this.formData, 'bindOpenBankName', '');
      this.$set(this.formData, 'drawOpenOrgNum', '');
      this.$refs.bankDown.hidePanel();
    },
    async editDrawOpenOrgNum(e) {
      this.formData.drawOpenOrgNum = e.value.replace(/\s+/g, "");
    },
    checkOrg(scope) {
      if (!this.isInputBank && (!this.formData.bindOpenOrgNum || !this.chooseBank)) {
        this.openBankName = this.formData.bindOpenBankName;
        this.formData.bindOpenBankName = "";
        // this.accountData.openOrgNum = "";
      }
      this.$refs.xForm1.updateStatus(scope);
    },
    openBindAccountModal() {
      this.isShowBindAccount = true;
      this.$nextTick(() => {
        this.$refs.BindAccount.init();
      });
    },
    editBankCount(e) {
      this.clearV();
      this.formData.bindAccNum = e.value.replace(/\s+/g, "");
    },
    closeAddAccount() {
      this.$nextTick(() => {
        this.$refs.addBankAccount.cancelSubmit();
      });
    },
    closeAccount() {
      this.createAccountModal = false;
    },
    getAccount(memInfo) {
      this.accountModal = true;
      this.$nextTick(() => {
        this.$refs.linkAccountList.init(memInfo);
      })
    },
    getAccList() {
      this.loading = true;
      $api.finance.queryAccListModel
          .POST({
            data: {
              page: this.page.currentPage,
              rows: this.page.pageSize,
              subjectType: 1,
              subjectId: this.userId,
              orderBy: 2,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              this.companyListData = res.data.rows;
              this.page.totalResult = res.data.total;
              this.loading = false;
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
    },
    getDetail(id) {
      var data = {
        id: id,
      };
      new Promise((resolve, reject) => {
        $api.gcdUser.queryGcdUserModel
            .POST({
              data,
            })
            .then((response) => {
              // if (response.data.auditStatus === 3) {
              //   this.idRead = true;
              // } else {
              //   this.idRead = false;
              // }
              let data = response.data;
              if (response.data.userType === 2) {
                this.userType = 2;
                this.userName = response.data.compName;
                this.$set(this.formData, 'compName', response.data.compName);
                this.formData.realname = response.data.realName;
                if (response.data.managerType === 1) {
                  this.formData.idno = response.data.idcardNum;
                  // if (response.data.auditStatus === 3) {
                  //   this.idNoRead = true;
                  // } else {
                  //   this.idNoRead = false;
                  // }
                }
                this.formData.identiNum = response.data.taxNum;
                this.formData.identiType = "b";
                this.formData.memType = 0;
                this.formData.phoneNumber = response.data.regisiterNum

                if (!data.compName) {
                  this.$XModal.alert({
                    message: "请先完善企业名称",
                    status: "error",
                  });
                  return
                }
                if (!data.taxNum) {
                  this.$XModal.alert({
                    message: "请先完善统一社会信用代码",
                    status: "error",
                  });
                  return
                }
                if (!data.realName) {
                  this.$XModal.alert({
                    message: "请先完善法人姓名",
                    status: "error",
                  });
                  return
                }
                this.isShowAddModal = true;
                this.getPlatformCorp();
              } else {
                this.userName = response.data.realName;
                this.userType = 1;
                this.formData.realname = response.data.realName;
                this.formData.idno = response.data.identiNum;
                this.formData.identiNum = response.data.idcardNum;
                this.formData.memType = 1;
                this.formData.identiType = 1;
                this.formData.phoneNumber = response.data.regisiterNum;

                if (!data.realName) {
                  this.$XModal.alert({
                    message: "请先完善姓名",
                    status: "error",
                  });
                  return
                }
                if (!data.idcardNum) {
                  this.$XModal.alert({
                    message: "请先完善身份证号码",
                    status: "error",
                  });
                  return
                }
                this.isShowAddModal = true;
                this.getPlatformCorp();
              }
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    createCompanyInfo(type, obj) {
      // 开通公司子账户
      // identiType： f-营业执照
      // subjectType： 0-平台
      //  isCrossLine Char（2） 是 否 01-行内 02-跨行
      this.type = type;
      if (this.$refs.xForm1) {
        this.$refs.xForm1.clearValidate();
      }
      // this.$refs.xForm.clearValidate();
      if (type === 0) {
        this.isUpdate = false;
        this.modalTitle = "开通子账户";
        this.formData = {
          realname: null, // 法人姓名
          idno: null, // 法人身份证号码
          identiNum: null, // 统一社会信用代码
          bindAccName: null, // 结算账户
          bindAccNum: null, // 结算银行账号
          busiSubjectName: null, // 公司名称
          subjectId: this.userId, // 平台公司id
          bindOpenBankName: null, // 结算开户银行
          bindOpenOrgNum: null,
          isCrossLine: "02",
          phoneNumber: null
        };
        this.getDetail(this.userId);
      } else {
        this.isUpdate = true;
        this.modalTitle = "编辑子账户";
        this.getDetail(this.userId);
        console.log(obj, "obbb");
        this.formData = JSON.parse(JSON.stringify(obj));
      }
      this.isInputBank = false;
      this.isExist = false;
    },
    bindCompanyInfo() {
      var data = {
        subjectName: this.userName
      };
      this.formDataTwo = {}
      new Promise((resolve, reject) => {
        $api.finance.queryCompanyMemByNameModel
            .POST({
              data,
            })
            .then((response) => {
              if (response.status === 1) {
                this.formDataTwo = response.data;
                this.isShowAddTwoModal = true;
                this.getAccList();
              } else {
                this.$XModal.alert({
                  message: response.message ? response.message : "接口异常",
                  status: "error",
                });
              }
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    refresh() {
      // 刷新
      this.getAccList();
    },
    handlePageChange() {
      // 分页
      this.getAccList();
    },
    submitEvent() {
      let self = this;
      // 提交
      let txt = this.type === 0 ? "添加成功！" : "修改成功！";
      // 提交
      let obj = {
        subjectType: 1,
        subjectId: this.formData.subjectId,
        subjectName: this.userName,
        identiNum: this.formData.identiNum,
        realname: this.formData.realname,
        idno: this.formData.idno,
        bindAccName: this.formData.bindAccName ? this.formData.bindAccName : this.userType === 2 ? this.formData.compName : this.formData.realname,
        bindAccNum: this.formData.bindAccNum,
        bindOpenBank: this.formData.bindOpenBank,
        bindOpenOrgNum: this.formData.bindOpenOrgNum,
        bindOpenBankName: this.formData.bindOpenBankName,
        busiSubjectId: this.formData.busiSubjectId,
        busiSubjectName: this.formData.busiSubjectName,
        isCrossLine: this.formData.isCrossLine,
        identiType: this.formData.identiType,
        memType: this.formData.memType,
        phoneNumber: this.formData.phoneNumber,
      };
      if (this.formData.isCrossLine == "01") {
        obj.bindOpenOrgNum == null
      }
      if (this.type === 0) {
        showLoading();
        $api.finance.createMemModel
            .POST({
              data: obj,
            })
            .then((res) => {
              hideLoading();
              if (res.status === 1) {
                this.$XModal.message({message: txt});
                this.isShowAddModal = false;
                this.getAccList();
                // this.queryUserListByObj(this.paramsObj);
              } else {
                this.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error",
                });
              }
            }).catch(function (er) {
          hideLoading();
          console.log(er.response.data.message);
          self.$XModal.alert({
            message: er.response.data.message
                ? er.response.data.message
                : "接口异常",
            status: "error",
          });
          return;
        })
      } else {
        showLoading();
        $api.finance.updateMemModel
            .POST({
              data: obj,
            })
            .then((res) => {
              hideLoading();
              if (res.status === 1) {
                this.$XModal.message({message: txt});
                this.isShowAddModal = false;
                this.getAccList();
                // this.queryUserListByObj(this.paramsObj);
              } else {
                this.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error",
                });
              }
            }).catch(function (er) {
          hideLoading();
          console.log(er.response.data.message);
          self.$XModal.alert({
            message: er.response.data.message
                ? er.response.data.message
                : "接口异常",
            status: "error",
          });
          return;
        });
      }
    },
    submitEventTwo() {
      var data = {
        companyId: this.formDataTwo.subjectId,
        userSignId: this.userId
      };
      this.formDataTwo = {}
      new Promise((resolve, reject) => {
        $api.finance.userBindCompanyMemModel
            .POST({
              data,
            })
            .then((response) => {
              this.isShowAddTwoModal = false;
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    openUser() {
      // test
    },
    chainIdCellClickEvent() {
      // test
    },
    chainIdPageChange() {
      // tets
    },
    openContract() {
      // tets
    },
    cancelEvent() {
      this.isShowAddModal = false;
      this.isShowAddTwoModal = false;
    },
    search() {
      this.tablePage.currentPage = 1;
      this.getCompanyList();
    },
    focusEvent(name) {
      let refs = this.$refs[name];
      refs.showPanel();
      this.searchName = null;
      this.tablePage = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      };
      switch (name) {
        case "companyDown":
          this.getCompanyList();
          break;
        case "accDown":
          this.getPlatformCorp();
      }
      this.$refs.xForm.clearValidate("bindAccName");
    },
    cellClickEvent({row}) {
      console.log(row);
      this.formData.busiSubjectName = row.name;
      this.formData.busiSubjectId = row.id;
      this.$set(this.formData, 'bindAccName', null);
      this.$set(this.formData, 'bindAccNum', null);
      this.$set(this.formData, 'bindOpenBankName', null);
      this.$set(this.formData, 'bindOpenOrgNum', null);
      this.$set(this.formData, 'drawOpenOrgNum', null);
      this.isExist = false;
      this.isInputBank = false;
      this.$refs.companyDown.hidePanel();
      this.$refs.xForm.clearValidate("busiSubjectName");
      this.clearV();
    },

    async getCompanyList() {
      let params = {
        orderBy: 2,
        page: this.tablePage.currentPage,
        rows: this.tablePage.pageSize,
      };
      if (!isEmpty(this.searchName)) {
        params.name = this.searchName;
      }
      if (isEmpty(this.tableData)) {
        this.loading = true;
      }
      let res = await $api.finance.post(
          "cebBusiMem/queryCompanyWithBusi",
          params
      );
      this.loading = false;
      if (res.status === 1) {
        this.tableData = res.data.rows;
        this.tablePage.total = res.data.total;
      }
    },
    pageChange(e) {
      this.tablePage.currentPage = e.currentPage;
      this.tablePage.pageSize = e.pageSize;
      this.getCompanyList();
    },
    async getPlatformCorp() {
      let res = await $api.baseUserSignBank.request("queryUserBankList", {
        userId: this.userId,
      });
      this.accTableData = res.data;
      if (this.accTableData.length === 0) {
        this.$XModal.confirm('请先添加银行账户').then(type => {
          if (type === "confirm") {
            this.createAccountModal = true;
            this.$nextTick(() => {
              this.$refs.addBankAccount.init();
            });
          }
        })
      }
    },
    accPageChange() {
    },
    accCellClickEvent({row}) {
      this.isInputBank = false;
      this.isExist = false;
      this.formData.bindAccName = row.accountName;
      this.formData.bindAccNum = row.accountNum;
      this.formData.bindOpenBankName = row.openBankName;
      this.formData.bindOpenOrgNum = row.openOrgNum;
      this.clearV();
      this.$refs.accDown.hidePanel();
    },
    bankFocusEvent() {
      if (!this.isInputBank) {
        this.$refs.bankDown.showPanel();
      }
    },
    bankKeyupEvent() {
      this.clearV();
      if (!this.isInputBank) {
        this.chooseBank = false;
        this.getBankListByName();
      }
    },
    bankSelectEvent(obj) {
      this.clearV();
      this.formData.bindOpenBankName = obj.orgName;
      this.formData.bindOpenOrgNum = obj.orgNum;
      this.$refs.bankDown.hidePanel();
    },
    bankBlurEvent(obj) {
      this.getBankListByName();
      if (this.bankList.length === 1) {
        this.formData.bindOpenBankName = obj.orgName;
        this.formData.bindOpenOrgNum = obj.orgNum;
      } else {
        this.formData.bindOpenBankName = null;
        this.formData.bindOpenOrgNum = null;
      }
    },
    async getBankListByName() {
      let name = this.formData.bindOpenBankName;
      if (isEmpty(name)) {
        this.bankList = [];
        return
      }
      let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
      if (res.status === 1 && name === res.message) {
        this.bankList = res.data;
      }
    },
  },
};
</script>

<style>
.company-dropdown4 {
  width: 400px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}

.company-dropdown4 .ivu-input-wrapper {
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
}

.company-dropdown4 .ivu-input {
  border-radius: 0;
}

.my-form2 .vxe-pulldown {
  width: 100%;
}

.my-form2 .sel-link-text {
  border: 1px solid #dcdfe6;
  width: 100%;
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  text-indent: 8px;
  color: #2d8cf0;
  position: relative;
}

.my-form2 .sel-link-text .vxe-icon--arrow-bottom {
  color: #999;
  position: absolute;
  right: 10px;
  top: 8px;
}

.my-dropdown1 {
  height: 200px;
  overflow: auto;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
}

.list-item1:hover {
  background-color: #f5f7fa;
}

.bank-tip {
  display: block;
  color: #f00;
  padding-left: 150px;
}
</style>
